import * as mutation from "./mutation-types";
import * as action from "./action-types";
import { deepCopy, deepCopyAxiosException } from "@/store/helpers";
import { tableHelper } from "@/helpers/table.helper";
import axios from "axios";
import { GLOBAL_ERROR } from "@/store/system/mutation-types";
import { addFiltersToCriteria } from "./helpers";

export const actions = {
  async [action.LIST]({ commit, state }) {
    commit(mutation.LIST_STARTED);
    try {
      const criteria = addFiltersToCriteria(deepCopy(state.listing.criteria), state);
      const url = tableHelper.constructUrl(`/api/users/authentication-logs`, state.listing.paging, criteria);
      const { headers, data } = await axios.get(url);
      commit(mutation.LIST_SET_CRITERIA_DESCRIPTION, tableHelper.getCriteriaInfo(headers));
      commit(mutation.LIST_SET_PAGING, tableHelper.getPagingFromHeaders(headers));
      commit(mutation.LIST_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.LIST_FAILED, deepCopyAxiosException(e));
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },

  async [action.EXPORT]({ commit, state }) {
    commit(mutation.EXPORT_STARTED);
    try {
      const criteria = addFiltersToCriteria(deepCopy(state.listing.criteria), state);
      await axios.get(tableHelper.constructUrl("/api/exports/validate/authentication-logs", criteria));
      const url = tableHelper.constructUrl("/api/exports/authentication-logs", criteria);
      tableHelper.downloadExportedSpreadsheet(url);
      commit(mutation.EXPORT_SUCCEEDED);
      return true;
    } catch (e) {
      commit(mutation.EXPORT_FAILED, deepCopyAxiosException(e));
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  }
};
